const OPEN_SUPPORT_EVENT = 'printen:open-support';
let pending = false;
const subscribers = new Set<() => void>();

function consumePending() {
  const listener = subscribers.values().next().value;
  if (!pending || !listener) return;
  // Clear before notifying, including during Strict Mode effect remounts.
  pending = false;
  listener();
}

/** Coalesce early clicks until the lazy assistant is ready. No SSR state. */
export function requestSupport() {
  if (typeof window === 'undefined') return;
  pending = true;
  consumePending();
}

/** The raw event remains supported once subscribed; UI callers use requestSupport. */
export function subscribeSupportRequests(listener: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  const target = window;
  if (subscribers.size === 0) target.addEventListener(OPEN_SUPPORT_EVENT, requestSupport);
  // Each subscription has its own identity, even with the same callback.
  const subscription = () => listener();
  subscribers.add(subscription);
  consumePending();
  return () => {
    subscribers.delete(subscription);
    if (subscribers.size === 0) target.removeEventListener(OPEN_SUPPORT_EVENT, requestSupport);
  };
}
